import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useInView } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import './About.css';

const CountUp = ({ end, suffix = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, end]);

  return <span ref={ref}>{count}{suffix}</span>;
};

const About = () => {
  const { t } = useTranslation();

  const highlightKeys = ['enterprise', 'agile', 'dedicated', 'support247', 'scalable', 'security'];

  return (
    <section id="about" className="section about-section">
      <div className="container">
        <div className="about-grid">
          <motion.div
            className="about-content"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-tag">{t('about.sectionTag')}</span>
            <h2 className="section-title">{t('about.title')}</h2>
            <p className="about-desc">{t('about.desc1')}</p>
            <p className="about-desc">{t('about.desc2')}</p>

            <div className="about-highlights">
              {highlightKeys.map((key, idx) => (
                <motion.div
                  key={key}
                  className="highlight-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: idx * 0.1 }}
                >
                  <FiCheckCircle className="highlight-icon" />
                  <span>{t(`about.highlights.${key}`)}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="about-stats-grid"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="stat-card stat-card-1">
              <div className="stat-number"><CountUp end={500} suffix="+" /></div>
              <div className="stat-label">{t('about.stats.projects')}</div>
            </div>
            <div className="stat-card stat-card-2">
              <div className="stat-number"><CountUp end={200} suffix="+" /></div>
              <div className="stat-label">{t('about.stats.clients')}</div>
            </div>
            <div className="stat-card stat-card-3">
              <div className="stat-number"><CountUp end={18} suffix="+" /></div>
              <div className="stat-label">{t('about.stats.experience')}</div>
            </div>
            <div className="stat-card stat-card-4">
              <div className="stat-number">24/7</div>
              <div className="stat-label">{t('about.stats.support')}</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
